import React, { memo, useContext } from 'react'

import Button from 'components/CommonUI/Button/Button'
import FilterItem from './FilterItem'

import { DeviceContext } from '../DeviceConnectionContainer'
import { getAdminProfileDataSelector } from 'redux/reducers/devices'
import { useShallowEqualSelector } from 'custom-hooks'

const PageFilter = () => {
  const adminProfileData = useShallowEqualSelector(getAdminProfileDataSelector)

  const { state, actions } = useContext(DeviceContext)
  const {
    selectedUserValue = {},
    selectedLocationValue = {},
    selectedPanelValue = {},
    selectedMeterValue = {},
  } = state

  const {
    setSelectedUserValue,
    setSelectedLocationValue,
    setSelectedPanelValue,
    setSelectedMeterValue,
    clearAllFiltersValue,
  } = actions

  const disabledClearButton =
    !selectedUserValue?.value &&
    !selectedLocationValue?.value &&
    !selectedPanelValue?.value &&
    !selectedMeterValue?.value

  return (
    <div className="page_filter_container">
      <div className="left_section">
        <FilterItem
          emptyValue={!adminProfileData.length ? 'No users' : 'Select user'}
          itemData={adminProfileData}
          count="1"
          handleSelectedClick={setSelectedUserValue}
          selectedValue={selectedUserValue}
          disabled={!adminProfileData.length}
        />
        <FilterItem
          emptyValue={
            selectedUserValue?.value?.locations.length === 0
              ? 'No locations'
              : 'Select location'
          }
          itemData={selectedUserValue?.value?.locations}
          selectedValue={selectedLocationValue}
          handleSelectedClick={setSelectedLocationValue}
          count="2"
          disabled={
            !selectedUserValue?.value ||
            !selectedUserValue?.value?.locations.length
          }
        />
        <FilterItem
          emptyValue={
            selectedLocationValue?.value?.panels.length === 0
              ? 'No panels'
              : 'Select panel'
          }
          itemData={selectedLocationValue?.value?.panels}
          count="3"
          disabled={
            !selectedLocationValue?.value ||
            !selectedLocationValue?.value?.panels.length
          }
          selectedValue={selectedPanelValue}
          handleSelectedClick={setSelectedPanelValue}
        />
        <FilterItem
          emptyValue={
            selectedPanelValue?.value?.meters?.length === 0
              ? 'No meters'
              : 'Select meter'
          }
          itemData={selectedPanelValue?.value?.meters}
          count="4"
          disabled={
            !selectedPanelValue?.value ||
            !selectedPanelValue?.value?.meters?.length
          }
          handleSelectedClick={setSelectedMeterValue}
          selectedValue={selectedMeterValue}
        />
      </div>
      <div className="right_section">
        <Button
          variant="text"
          onClick={clearAllFiltersValue}
          disabled={disabledClearButton}
        >
          Clear filters
        </Button>
      </div>
    </div>
  )
}

export default memo(PageFilter)
